/* Dogs Supreme – Sticky Cart Bar v26 (2026-07-24)
 * Floating Glass-Card Show/Hide + Cart-Add + Variant-Sync.
 * Tracking via fetch /cart/add.js → ds-cart-tracking.js Interceptor (kein Doppel-Tracking).
 * Show/Hide v25: richtungsbewusst – die Bar erscheint NUR, wenn der Haupt-ATC nach oben
 * aus dem Viewport gescrollt ist. Beim Laden (Inline-CTA liegt noch darunter) bleibt sie
 * versteckt, damit sie den Subtitle / die Produktvorteile nicht verdeckt.
 * v26: (a) Groessenwahl-Kopplung – Sticky-Klick ohne bewusste Groessenwahl fuehrt erst
 * zur Groessen-Gruppe (verhindert Default-Groesse-Fehlkauf/Retoure). (b) dataLayer-
 * Instrumentierung ds_sticky_atc_shown / _click / _size_nudge fuer Impact-Messung.
 * v27: nur unter 769px (einspaltige PDP). Ab 769px ist die PDP zweispaltig, die Buybox
 * mit Inline-CTA steht dauerhaft rechts -> kein Sticky auf Tablet-Landscape/Desktop.
 */

(function() {
  'use strict';

  var bar = document.getElementById('DsCartBar');
  var btn = document.getElementById('DsCartBarBtn');
  var priceEl = document.getElementById('DsCartBarPrice');
  var textEl = document.getElementById('DsCartBarText');
  if (!bar || !btn || !textEl) return;

  var DEBUG = /[?&]ds_debug=1/.test(location.search);
  var sectionId = btn.getAttribute('data-section-id');
  var currentVariantId = parseInt(btn.getAttribute('data-variant-id'), 10);
  /* Die Wahl auch ins Attribut schreiben: die v2-Ereignisse von Arm B lesen
     data-variant-id und meldeten sonst die Startvariante (VG-2610-DVYPF). */
  function setVariant(id) {
    currentVariantId = id;
    btn.setAttribute('data-variant-id', id);
  }
  var labelAdd = btn.getAttribute('data-label-add') || 'In den Warenkorb';
  var labelSoldout = btn.getAttribute('data-label-soldout') || 'Ausverkauft';
  var labelAdding = btn.getAttribute('data-label-adding') || 'Wird hinzugefuegt…';
  var labelAdded = btn.getAttribute('data-label-added') || 'Hinzugefuegt ✓';

  function log() {
    if (!DEBUG) return;
    var args = ['[DS-CartBar]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  /* ─── Money-Formatter (umgeht theme.Currency.formatMoney HTML-Bug) ─── */
  function dsFormatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ─── Show / Hide ─── */
  var shownTracked = false;   // ds_sticky_atc_shown genau 1x pro Page-View
  function show() {
    bar.setAttribute('data-state', 'visible');
    bar.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-has-cart-bar', 'visible');
    if (!shownTracked) {
      shownTracked = true;
      if (window.dataLayer) window.dataLayer.push({ event: 'ds_sticky_atc_shown', variant_id: currentVariantId });
    }
    log('show');
  }

  function hide() {
    bar.setAttribute('data-state', 'hidden');
    bar.setAttribute('aria-hidden', 'true');
    document.body.removeAttribute('data-has-cart-bar');
    log('hide');
  }

  /* ─── Show/Hide-Mechanik v25 (2026-07-24): richtungsbewusst ───
   * Die Bar erscheint AUSSCHLIESSLICH, wenn der Haupt-ATC-Button nach OBEN aus dem
   * Sichtfeld gescrollt ist (der Kunde hat den Inline-CTA passiert). Solange der Button
   * im Viewport ODER noch darunter liegt (Seitenaufruf: Kunde schaut Produkt + Vorteile
   * an), bleibt die Bar versteckt. Behebt: "nicht sichtbar" war bisher richtungslos
   * (unterhalb == oberhalb), deshalb erschien die Bar schon beim Laden und verdeckte
   * mobil den Subtitle. */
  var mainAtcBtn = document.querySelector('[data-add-to-cart]');

  // Hoehe eines fixierten/sticky Headers: die Bar erscheint, sobald der Button DAHINTER
  // rutscht (natuerlicher Uebergang). Kein fixer Header => 0 (Button ueber Viewport-Kante).
  function headerOffset() {
    var hdr = document.querySelector('.site-header') ||
              document.querySelector('.sn-header') ||
              document.querySelector('header');
    if (hdr) {
      var pos = window.getComputedStyle(hdr).position;
      if (pos === 'fixed' || pos === 'sticky') return hdr.getBoundingClientRect().height || 0;
    }
    return 0;
  }

  // Bei offenem Cart-Drawer/Menue nicht evaluieren (Overlay-Logik + CSS steuern die Sichtbarkeit).
  function overlayOpen() {
    var b = document.body, h = document.documentElement;
    return b.classList.contains('sn-cart-open') ||
           b.classList.contains('sn-menu-open') ||
           b.classList.contains('js-drawer-open') ||
           h.classList.contains('js-drawer-open');
  }

  function isShown() { return bar.getAttribute('data-state') === 'visible'; }

  // Hysterese gegen Kanten-Flackern: zeigen sobald die Unterkante hinter den Header rutscht,
  // verstecken erst wenn der Button wieder > SHOW_GAP darunter im Blick ist.
  var SHOW_GAP = 48;

  // Ab 769px (zweispaltige PDP, Buybox dauerhaft sichtbar) kein Sticky (GF 24.07.2026).
  function dsIsWide() {
    return !!(window.matchMedia && window.matchMedia('(min-width: 769px)').matches);
  }
  function evaluate() {
    if (!mainAtcBtn || overlayOpen()) return;
    if (dsIsWide()) { if (isShown()) hide(); return; }   // Desktop/Tablet-Landscape: nie zeigen
    var rect = mainAtcBtn.getBoundingClientRect();
    var threshold = headerOffset();
    // VG-2610-TSAS7 (28.10.2026): nur wo das Snippet data-ds-zeige-unten setzt (Vorlage
    // flexbox-box), auch zeigen, solange der Button noch UNTER dem Bildschirm liegt.
    var unten = bar.hasAttribute('data-ds-zeige-unten') &&
      rect.top >= (window.innerHeight || document.documentElement.clientHeight);
    if (!isShown()) {
      // NUR zeigen, wenn der Button nach OBEN raus ist. Noch/wieder im Blick oder
      // darunter (rect.bottom > threshold) => versteckt lassen.
      if (rect.bottom <= threshold || unten) show();
    } else {
      if (rect.bottom > threshold + SHOW_GAP && !unten) hide();
    }
  }

  if (mainAtcBtn) {
    // rAF-throttled Scroll/Resize: robust auf allen Browsern (kein IO-Timing-Risiko),
    // max. 1x getBoundingClientRect pro Frame.
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() { evaluate(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('orientationchange', onScroll, { passive: true });

    // IntersectionObserver als zusaetzlicher Trigger fuer saubere Grenzuebergaenge.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function() { evaluate(); }, { threshold: [0, 1] }).observe(mainAtcBtn);
    }

    // Initialzustand nach Layout bestimmen (Bar startet versteckt via data-state="hidden").
    requestAnimationFrame(evaluate);
    window.addEventListener('load', evaluate);
  }
  // Kein forced-show-Fallback ohne Sentinel: ohne verfuegbaren ATC (ausverkauft) rendert
  // die Bar (sticky-atc.liquid) ohnehin nicht.

  /* ─── Groessenwahl-Kopplung (v26) ───────────────────────────────────────────
   * Produkte mit Groessen-Auswahl haben beim Laden immer eine Default-Groesse
   * vorgewaehlt. Der weit weggescrollte Sticky-Kunde sieht sie nicht (die Bar zeigt
   * nur Titel + Preis) -> Default-Fehlkauf (z.B. XL) -> Falschgroessen-Retoure.
   * Deshalb fuehrt ein Sticky-Klick OHNE bewusste Groessenwahl erst zur Groessen-Gruppe.
   * Anker: Fieldset mit .dsrc-sizes ODER data-handle "grosse"/"groesse"/"size" ODER
   * name "Größe"/"Grösse"/"Size" (server-gerendert in variant-button.liquid, robust
   * gegen die dynamisch gesetzte .dsrc-sizes-Klasse). */
  function dsSizeGroup() {
    var wraps = document.querySelectorAll('.variant-input-wrap');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.classList.contains('dsrc-sizes')) return w;
      var handle = (w.getAttribute('data-handle') || '').toLowerCase();
      var name = (w.getAttribute('name') || '').toLowerCase();
      if (handle === 'grosse' || handle === 'groesse' || handle === 'size' ||
          name.indexOf('größe') > -1 || name.indexOf('grösse') > -1 ||
          name.indexOf('groesse') > -1 || name.indexOf('size') > -1) return w;
    }
    return null;
  }
  // Bewusste Wahl = Kunde interagiert mit der Groessen-Gruppe (Klick/Change auf Radio/Label).
  var dsSizeChosen = false;
  function dsMarkChosen(e) {
    if (window.dsVorwahlLaeuft) return;                  // Vorwahl-Skript (ds-variant-selector) ist keine bewusste Wahl, VG-2609-MDJ33
    var g = dsSizeGroup();
    if (g && e.target && g.contains(e.target)) dsSizeChosen = true;
  }
  document.addEventListener('change', dsMarkChosen, true);
  document.addEventListener('click', dsMarkChosen, true);

  function dsNeedsSizeChoice() {
    var g = dsSizeGroup();
    if (!g) return false;                                  // Produkt ohne Groessen-Auswahl
    return g.querySelectorAll('input[type="radio"]').length >= 2 && !dsSizeChosen;
  }
  // SafeRide-Zusatz (26.09.2026, VG-2609-ZW644, Variante A): Groesse gewaehlt, Zusatz
  // lieferbar, nicht angehakt und noch nie im Blick -> der erste Sticky-Klick scrollt
  // einmal je Seitenaufruf zum Zusatz, der zweite kauft. Gleiches Muster wie dsNudgeSize.
  var dsSrRoot = null, dsSrSeen = false, dsSrNudged = false;
  function dsSrInit() {
    if (dsSrRoot) return;
    dsSrRoot = document.querySelector('[data-saferide-addon]');
    if (dsSrRoot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(en) {
        if (en[0].isIntersecting && !dsSrRoot.hidden) dsSrSeen = true;
      }, { threshold: 0.6 }).observe(dsSrRoot);
    }
  }
  dsSrInit();
  document.addEventListener('DOMContentLoaded', dsSrInit);
  function dsNeedsAddonLook() {
    dsSrInit();
    if (!dsSrRoot || dsSrRoot.hidden || dsSrSeen || dsSrNudged) return false;
    var c = dsSrRoot.querySelector('[data-addon-check]');
    return !!c && !c.disabled && !c.checked;
  }
  function dsNudgeSize(target) {
    var g = target || dsSizeGroup();
    if (!g) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var off = headerOffset() + 16;
    var targetY = Math.max(0, g.getBoundingClientRect().top + (window.pageYOffset || 0) - off);
    // scrollIntoView (robuster als scrollTo({behavior})) + inline scroll-margin fuer den
    // fixen Header. Smooth wenn erlaubt.
    g.style.scrollMarginTop = off + 'px';
    try { g.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); }
    catch (ex) { window.scrollTo(0, targetY); }
    // Absicherung: schlaegt native smooth nicht an, nach 400ms hart ans Ziel
    // (verhindert "Klick ohne sichtbaren Effekt").
    setTimeout(function() {
      if (Math.abs((window.pageYOffset || 0) - targetY) > 40) window.scrollTo(0, targetY);
    }, 400);
    // dezenter Puls (synchroner Reflow statt rAF -> zuverlaessiger Animations-Restart)
    g.classList.remove('ds-size-nudge');
    void g.offsetWidth;
    g.classList.add('ds-size-nudge');
    setTimeout(function() { g.classList.remove('ds-size-nudge'); }, 1800);
    if (!target && window.dataLayer) window.dataLayer.push({ event: 'ds_sticky_atc_size_nudge' });
  }

  /* ─── Add-to-Cart Click ─── */
  var isAdding = false;
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    if (btn.disabled || isAdding) return;

    // Kopplung: erst bewusste Groesse, dann Kauf.
    if (dsNeedsSizeChoice()) {
      dsNudgeSize();
      if (window.dataLayer) window.dataLayer.push({ event: 'ds_sticky_atc_click', outcome: 'size_nudge' });
      return;
    }
    if (dsNeedsAddonLook()) {
      dsSrNudged = true;
      dsNudgeSize(dsSrRoot);
      if (window.dataLayer) window.dataLayer.push({ event: 'ds_sticky_atc_click', outcome: 'addon_nudge' });
      return;
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'ds_sticky_atc_click', outcome: 'add', variant_id: currentVariantId });

    // SafeRide-Zusatz angehakt: ueber den Hauptknopf kaufen. Das Snippet
    // product-saferide-addon faengt dessen submit ab und legt Box und Zusatz in
    // EINEM /cart/add.js ab. Der eigene Add hier kannte das Haekchen nicht und
    // legte nur die Box ab (nachgestellt 26.09.2026, VG-2609-ZW644).
    var srCheck = document.querySelector('[data-saferide-addon] [data-addon-check]');
    if (srCheck && srCheck.checked && mainAtcBtn) {
      mainAtcBtn.click();
      return;
    }

    isAdding = true;
    btn.disabled = true;
    var origText = textEl.textContent;
    textEl.textContent = labelAdding;

    var _dsPackQ = document.querySelector('[data-ds-form-qty]');
    var _dsPackQty = _dsPackQ && parseInt(_dsPackQ.value, 10) > 0 ? parseInt(_dsPackQ.value, 10) : 1;
    var mainItem = { id: currentVariantId, quantity: _dsPackQty };
    if (window.__dsSellingPlan && window.__dsSellingPlan.id) {
      mainItem.selling_plan = window.__dsSellingPlan.id;
    }
    var cartItems = [mainItem];

    // Cross-Sell-Toggle (wenn aktiv): zweites Item dazu
    // FIX 2026-05-20: data-current-variant-id reflektiert aktuelle User-Selection;
    // initialVariantId war Page-Load-Default und ignorierte Variant-Wechsel → Bug "schwarzes Geschirr + rote Leine"
    var csToggle = document.querySelector('[data-ds-cs-toggle]');
    var csRoot = document.querySelector('[data-ds-cross-sell]');
    var csConfigEl = document.querySelector('[data-ds-cross-sell-config]');
    if (csToggle && csConfigEl && csToggle.getAttribute('aria-checked') === 'true') {
      try {
        var csConfig = JSON.parse(csConfigEl.textContent);
        var csVariantId = null;
        if (csRoot && csRoot.getAttribute('data-current-variant-id')) {
          csVariantId = parseInt(csRoot.getAttribute('data-current-variant-id'), 10);
        }
        if (!csVariantId && csConfig && csConfig.initialVariantId) {
          csVariantId = csConfig.initialVariantId;
        }
        if (csVariantId) {
          cartItems.push({ id: csVariantId, quantity: 1, properties: { '_upsell': '1' } });
        }
      } catch (ex) { /* silent */ }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add failed: ' + r.status);
      return r.json();
    })
    .then(function() {
      // Apple-iOS Light systemGreen #34C759 via CSS-Klasse (animated check + "Gute Wahl!")
      btn.classList.add('ds-cart-bar__btn--success');
      textEl.textContent = labelAdded;
      // CustomEvent triggert Cart-Drawer-Open + Cross-Sell-Reminder + Header-Cart-Count
      // ds-cart-tracking.js Interceptor hat den Fetch bereits erfasst → GA4 add_to_cart auto
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      setTimeout(function() {
        btn.classList.remove('ds-cart-bar__btn--success');
        textEl.textContent = origText;
        btn.disabled = false;
        isAdding = false;
      }, 2200);
    })
    .catch(function(err) {
      console.error('Sticky Cart Bar: Add failed', err);
      textEl.textContent = origText;
      btn.disabled = false;
      isAdding = false;
    });
  });

  /* ─── Variant-Sync: Preis + Verfuegbarkeit ─── */
  var variantSelect = document.getElementById('ProductSelect-' + sectionId);
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (!opt) return;
      setVariant(parseInt(opt.value, 10) || currentVariantId);
      btn.disabled = opt.disabled;
      textEl.textContent = opt.disabled ? labelSoldout : labelAdd;
    });
  }

  /* Image-Element fuer Variant-Sync (v24 Layout-Upgrade) */
  var imgEl = document.getElementById('DsCartBarImg');

  function dsUpdateStickyImage(variant) {
    if (!imgEl || !variant) return;
    var srcCandidate = null;
    if (variant.featured_image && variant.featured_image.src) {
      srcCandidate = variant.featured_image.src;
    } else if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      srcCandidate = variant.featured_media.preview_image.src;
    }
    if (!srcCandidate) return;
    /* Shopify CDN: append width-param so wir kein 5MB-Image laden */
    var sep = srcCandidate.indexOf('?') === -1 ? '?' : '&';
    if (!/[?&]width=/.test(srcCandidate)) srcCandidate = srcCandidate + sep + 'width=240';
    if (imgEl.getAttribute('src') !== srcCandidate) imgEl.setAttribute('src', srcCandidate);
  }

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      var v = e.detail.variant;
      setVariant(v.id);
      if (priceEl && v.price != null) priceEl.textContent = dsFormatMoney(v.price);
      btn.disabled = !v.available;
      textEl.textContent = v.available ? labelAdd : labelSoldout;
      dsUpdateStickyImage(v);
    }
  });

  var sectionContainer = document.querySelector('[data-section-id="' + sectionId + '"]');
  if (sectionContainer) {
    sectionContainer.addEventListener('variantPriceChange', function(e) {
      if (e.detail && e.detail.variant) {
        var v = e.detail.variant;
        setVariant(v.id);
        if (priceEl && v.price != null) priceEl.textContent = dsFormatMoney(v.price);
        dsUpdateStickyImage(v);
      }
    });
  }

  log('initialized', {
    sectionId: sectionId,
    initialVariant: currentVariantId,
    available: !btn.disabled
  });

  /* ════════════════════════════════════════════════════════════════════════
   * Variant-Image Auto-Scroll (v23 inline, statt separater Datei)
   * Bei JEDEM variant:change oder Color-Swatch-Klick auf Mobile/Tablet:
   * scroll smooth zum Hauptbild sodass Bild im oberen 25% des Viewports landet.
   * ════════════════════════════════════════════════════════════════════════ */
  (function variantImageScroll() {
    // Desktop ueberspringen
    if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;
    // 05.09.2026: ds-pdp-variant-sticky.js v4 besitzt den Scroll zum Bild (ein Ausloeser, Bildwechsel-Gate).
    // Liegt er vor, tritt diese Kopie zurueck, sonst scrollten beide, 720 ms versetzt (GF: ruckelig).
    if (window.__dsVariantScrollOwner) { log('VariantScroll: owner is ' + window.__dsVariantScrollOwner + ', skip'); return; }

    function findImageWrap() {
      return document.querySelector('.product__main-photos') ||
             document.querySelector('[data-product-single-media-group]') ||
             document.querySelector('[data-product-photos]');
    }

    function getHeaderHeight() {
      var hdr = document.querySelector('.site-header') ||
                document.querySelector('header') ||
                document.querySelector('.sn-header');
      return (hdr && hdr.offsetHeight) || 56;
    }

    function scrollToImage(variant) {
      var imgWrap = findImageWrap();
      if (!imgWrap) { log('VariantScroll: imgWrap not found'); return; }

      var headerH = getHeaderHeight();
      var rect = imgWrap.getBoundingClientRect();
      var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var imgPageTop = rect.top + pageY;
      var imgHeight = imgWrap.offsetHeight || rect.height || 375;
      var vh = window.innerHeight;
      var spaceAbove;
      if (imgHeight + headerH + 32 >= vh) {
        spaceAbove = headerH + 8;
      } else {
        spaceAbove = headerH + Math.max(8, (vh - headerH - imgHeight) * 0.25);
      }
      var targetY = Math.max(0, imgPageTop - spaceAbove);

      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      log('VariantScroll: targetY=' + targetY + ' currentY=' + currentY + ' reducedMotion=' + reducedMotion);

      if (reducedMotion || Math.abs(targetY - currentY) < 4) {
        var se = document.scrollingElement || document.documentElement;
        se.scrollTop = targetY;
        document.documentElement.scrollTop = targetY;
        document.body.scrollTop = targetY;
        return;
      }

      // Image-Flash-Animation als visueller Polish (CSS .ds-variant-flash).
      // Macht das Scroll-Snap visuell weicher: User-Aufmerksamkeit auf Image-Pop, nicht auf Scroll.
      var imgWrapFlash = findImageWrap();
      if (imgWrapFlash) {
        imgWrapFlash.classList.remove('ds-variant-flash');
        requestAnimationFrame(function() {
          imgWrapFlash.classList.add('ds-variant-flash');
        });
        setTimeout(function() {
          imgWrapFlash.classList.remove('ds-variant-flash');
        }, 700);
      }

      // Smooth-Scroll Strategie:
      // 1) CSS scroll-behavior:smooth setzen → folgende scrollTop-Writes werden smooth animiert
      // 2) Sync direct-write auf scrollingElement (Browser respektiert behavior bei smooth-css)
      // 3) Multiple writes (belt-and-suspenders fuer cross-browser)
      // 4) Reset scroll-behavior nach 1s
      var html = document.documentElement;
      var prevBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'smooth';

      var se = document.scrollingElement || document.documentElement;
      se.scrollTop = targetY;
      document.documentElement.scrollTop = targetY;
      document.body.scrollTop = targetY;
      try { window.scroll(0, targetY); } catch (e) {}

      log('VariantScroll: smooth-scroll via CSS scroll-behavior triggered, currentY=' + (window.pageYOffset||0));

      // Reset scroll-behavior nach Animation
      setTimeout(function() {
        html.style.scrollBehavior = prevBehavior || '';
      }, 1000);

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'ds_variant_image_revealed',
          variant_id: variant ? variant.id : null,
          method: 'auto_scroll'
        });
      }
    }

    // Trigger-Strategie (Root-Cause-fix):
    // Das eigentliche Problem ist NICHT Theme.js, sondern Browser-Focus-Scroll
    // (Browser scrollt Radio-Input ins View beim Click → scrollY = swatch-position).
    // Loesung: ~700ms warten (Browser-Focus-Scroll ist fertig), dann CLEAN smooth-scroll.
    // Plus: focus-scroll preventieren via mousedown-Listener mit pre-scroll Lock.
    var scrollDelay = 720;
    var scrollPending = null;

    // Preventionsmechanismus fuer Browser-Focus-Scroll auf Radio-Inputs:
    // Wenn User auf Swatch klickt, merken wir uns scrollY VOR dem Click.
    // Nach Focus-Scroll restore (per RAF) wir die scroll-Position.
    // → Browser-Scroll wird neutralisiert, unsere smooth-scroll-Animation laeuft ohne Race.
    var preClickScrollY = null;
    function isColorSwatch(el) {
      return el && (
        el.matches && (el.matches('[data-color-swatch]') ||
                       el.matches('.color-swatch') ||
                       el.matches('label[for*="swatch" i]') ||
                       el.matches('input[type="radio"][data-variant-input]'))
      );
    }
    document.addEventListener('mousedown', function(e) {
      var swatch = e.target.closest && e.target.closest('[data-color-swatch], .color-swatch, label[for*="swatch" i]');
      if (!swatch) return;
      preClickScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }, { capture: true, passive: true });
    document.addEventListener('touchstart', function(e) {
      var swatch = e.target.closest && e.target.closest('[data-color-swatch], .color-swatch, label[for*="swatch" i]');
      if (!swatch) return;
      preClickScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }, { capture: true, passive: true });
    // Nach Focus-Event: scroll-Position restoren (Browser-Focus-Scroll neutralisieren)
    document.addEventListener('focusin', function(e) {
      if (preClickScrollY === null) return;
      if (!e.target.matches || !e.target.matches('input[type="radio"]')) return;
      var lock = preClickScrollY;
      preClickScrollY = null;
      // RAF nach Browser-Focus-Scroll-Render: restore
      requestAnimationFrame(function() {
        var se = document.scrollingElement || document.documentElement;
        se.scrollTop = lock;
        document.documentElement.scrollTop = lock;
        document.body.scrollTop = lock;
      });
    }, { capture: true });

    function queueScroll(variant) {
      if (scrollPending) clearTimeout(scrollPending);
      scrollPending = setTimeout(function() {
        scrollPending = null;
        scrollToImage(variant);
      }, scrollDelay);
    }

    // Track previous option1 (= Color in DS-Setup) → nur scrollen wenn Color-Wechsel,
    // nicht bei Size-Wechsel (option2).
    var prevOption1 = null;
    document.addEventListener('variant:change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      // Erster Aufruf: prevOption1 setzen, nicht scrollen (initial load)
      if (prevOption1 === null) {
        prevOption1 = v.option1;
        return;
      }
      // Wenn option1 (Color) gleich → war Size-Aenderung → KEIN scroll
      if (v.option1 === prevOption1) {
        log('VariantScroll: size-only change (option1 unchanged), skip scroll');
        return;
      }
      prevOption1 = v.option1;
      log('VariantScroll: color change detected, queue scroll in ' + scrollDelay + 'ms');
      queueScroll(v);
    });

    document.addEventListener('ds:variantImageChanged', function(e) {
      if (e.detail && e.detail.variant) {
        queueScroll(e.detail.variant);
      }
    });

    // Click-Trigger als Backup (variant:change feuert nicht immer)
    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('[data-color-swatch], .color-swatch, label[for*="swatch"], input[type="radio"][data-variant-input]');
      if (!swatch) return;
      var name = (swatch.name || swatch.getAttribute('name') || '').toLowerCase();
      var dataIndex = (swatch.getAttribute('data-index') || '').toLowerCase();
      var label = swatch.tagName === 'LABEL' && swatch.htmlFor ? document.getElementById(swatch.htmlFor) : null;
      var labelName = label ? (label.name || '').toLowerCase() : '';
      var isColor = name.includes('farbe') || name.includes('color') ||
                    labelName.includes('farbe') || labelName.includes('color') ||
                    swatch.matches('[data-color-swatch]') || swatch.matches('.color-swatch') ||
                    dataIndex === 'option1';
      if (!isColor) return;
      log('VariantScroll: color-swatch click, queue scroll in ' + scrollDelay + 'ms');
      queueScroll(null);
    });

    log('VariantScroll: initialized (mobile/tablet)');
  })();

  /* ─── Cart-Drawer-Sync: Hide Sticky-Bar wenn Drawer offen (Bug-Fix 2026-05-20) ─── */
  /* CSS macht visuelle Hide via !important. JS synct State-Attrs + a11y. */
  (function drawerSyncHide() {
    function isDrawerOpen() {
      return document.body.classList.contains('sn-cart-open') ||
             document.documentElement.classList.contains('js-drawer-open') ||
             document.body.classList.contains('js-drawer-open');
    }
    function applyHidden() {
      bar.setAttribute('data-state', 'hidden');
      bar.setAttribute('aria-hidden', 'true');
    }
    function reEval() {
      if (isDrawerOpen()) {
        applyHidden();
        log('drawer-open -> bar hidden (state+aria sync)');
      } else {
        log('drawer-close -> bar visibility re-eval via scroll-event');
        window.dispatchEvent(new Event('scroll'));
      }
    }
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class') { reEval(); return; }
        }
      });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      log('drawer-sync observer attached');
    }
    // ajaxProduct:added Event: Sticky-Bar sofort hiden (Drawer wird gleich danach geoeffnet)
    document.addEventListener('ajaxProduct:added', function() {
      applyHidden();
      log('ajaxProduct:added -> bar hidden');
    });
  })();

})();


/* ──────────────────────────────────────────────────────────────────────────
   Sticky-Cart-Leiste, Arm B des A/B-Tests. 28.07.2026.
   Experiment: sticky-cart-bar-klickflaeche-2026-07-28

   Befund (evidence/2026-07-28/sticky-bar-diagnose/REPORT.md): 129 Anzeigen in
   4 Tagen, 1 Klick. Von 351 px Leistenbreite sind 141 klickbar, der Knopf traegt
   ein drittes Blau statt der Farbe des Haupt-ATC, und die vom Kunden gewaehlte
   Groesse steht nirgends.

   Warum A/B und nicht Vorher/Nachher: am selben Tag gingen vier weitere
   Aenderungen live (Varianten-Deeplinks, CTA-Klickflaeche in allen Artikeln,
   13 entfernte Leinen-CTAs, Warenkorb im Groessenfinder). Alle wirken auf die
   mobile Warenkorb-Rate. Ein Vorher/Nachher-Vergleich wuerde die Summe aus fuenf
   Aenderungen dieser Leiste zuschreiben. Im Split erleben beide Arme dieselben
   vier Aenderungen, der Unterschied ist ausschliesslich die Leiste.

   Messung ohne GA4-Admin: customEvent:experiment_group ist nicht als Dimension
   registriert (live geprueft, "not a valid dimension"). Deshalb feuert Arm B
   ZUSAETZLICH _v2-Ereignisse. Auswertung:
     Arm B = ds_sticky_atc_*_v2
     Arm A = ds_sticky_atc_* minus ds_sticky_atc_*_v2
   Der Bestandscode bleibt dadurch unangetastet.

   Kein MutationObserver: ein Beobachter, dessen Rueckruf ins beobachtete DOM
   schreibt, hat heute schon eine Seite lahmgelegt (gleicher Text neu gesetzt
   zaehlt als Mutation). Stattdessen ein Intervall, und jede Schreiboperation
   prueft vorher auf Gleichheit. sync() ist damit idempotent.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var EXP = 'sticky_cartbar_klickflaeche_2026_07';
  var STYLE_ID = 'ds-cartbar-b-style';
  var KNOPF_BG = '#25282a';   // GF-Entscheidung: Farbe des Haupt-ATC
  var LABEL = 'In die Tasche';

  /* Zuteilung nach der Konvention von ds-experiments.js (localStorage, 50/50).
     Bewusst hier statt dort: die Leiste laeuft auf allen Produktseiten,
     ds-experiments.js ist auf zwei Pilot-Handles begrenzt. */
  function gruppe() {
    var key = 'ds_exp_' + EXP;
    try {
      var s = localStorage.getItem(key);
      if (s === 'A' || s === 'B') return s;
    } catch (e) { return 'A'; }   // Private-Mode: Kontrollgruppe, nie umbauen
    var g = Math.random() < 0.5 ? 'A' : 'B';
    try { localStorage.setItem(key, g); } catch (e2) {}
    return g;
  }

  var ARM = gruppe();
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ds_experiment_assigned', experiment_id: EXP, experiment_group: ARM });
  } catch (e) {}

  if (ARM !== 'B') return;   // Arm A bleibt bitgleich zum Bestand

  function push(ev, daten) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev, experiment_id: EXP, experiment_group: 'B' }, k;
      if (daten) for (k in daten) o[k] = daten[k];
      window.dataLayer.push(o);
    } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', ev, daten || {}); } catch (e2) {}
  }

  /* Schreiben nur bei echter Aenderung: haelt sync() idempotent. */
  function setText(el, wert) { if (el && el.textContent !== wert) el.textContent = wert; }

  /* Knopf-Farbe als Inline-Stil mit important. Im Erfolgszustand ("Gute Wahl!")
     traegt das Theme selbst ein gruenes !important, dann wird der Inline-Stil
     zurueckgenommen, sonst bliebe die Bestaetigung unsichtbar. */
  function faerbeKnopf(btn) {
    if (!btn) return;
    var erfolg = btn.classList.contains('ds-cart-bar__btn--success');
    /* Marker im DOM statt Vergleich des CSS-Wertes. Der Browser normalisiert
       '#25282a' zu 'rgb(37, 40, 42)', ein Vergleich gegen die Hex-Form schlaegt
       deshalb immer fehl. Live beobachtet: der Stil wurde dadurch alle 400 ms neu
       gesetzt, die Theme-Transition (background 0.25s) startete jedes Mal neu und
       der Knopf blieb dauerhaft in der Startfarbe stehen. */
    if (erfolg) {
      if (btn.getAttribute('data-ds-b-farbe')) {
        btn.style.removeProperty('background');
        btn.style.removeProperty('background-color');
        btn.removeAttribute('data-ds-b-farbe');
      }
      return;
    }
    if (!btn.getAttribute('data-ds-b-farbe')) {
      btn.style.setProperty('background', KNOPF_BG, 'important');
      btn.setAttribute('data-ds-b-farbe', '1');
    }
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    /* !important ist noetig: das Theme-CSS setzt Hintergrund und Groesse des
       Knopfes selbst mit !important. Ohne das hier bleibt der Knopf blau. */
    /* Die Knopf-Farbe steht bewusst NICHT hier. Eine Regel
       #DsCartBar[data-ds-b] #DsCartBarBtn{background:...!important} wurde live
       getestet: sie steht im Stylesheet, der Selektor trifft, sie traegt
       !important und hat die hoehere Spezifitaet, und trotzdem gewinnt die
       Theme-Regel .ds-cart-bar__btn. Die Farbe wird deshalb als Inline-Stil mit
       important gesetzt, siehe faerbeKnopf(). Inline mit important schlaegt
       jede Stylesheet-Regel, das ist in der Demo verifiziert. */
    s.textContent =
      '#DsCartBar[data-ds-b] .ds-cart-bar__img{display:none!important}' +
      '#DsCartBar[data-ds-b] #DsCartBarBtn{font-size:17px!important;padding:13px 17px!important}' +
      '#DsCartBar[data-ds-b]{cursor:pointer}' +
      '#DsCartBar[data-ds-b] .ds-cart-bar__price{white-space:nowrap}';
    (document.head || document.documentElement).appendChild(s);
  }

  /* Gewaehlte Groesse aus dem Produktformular, nicht aus dem Leisten-Text. */
  function groesse() {
    var g = null;
    var radios = document.querySelectorAll('input[type=radio]:checked');
    for (var i = 0; i < radios.length; i++) {
      var v = (radios[i].value || '').trim();
      var m = v.match(/^(3XS|XXXS|XXS|2XS|XS|S|M|L|XL|2XL|XXL|3XL|XXXL|4XL|5XL)(?:\s·.*)?$/); // Pilot 05.09.2026: Groessenwert darf einen Zusatz tragen (M · 43–49 cm)
      if (m) { g = m[1]; break; }
    }
    return g;
  }

  var ZUSATZ = ' · Größe ';

  function sync() {
    var bar = document.getElementById('DsCartBar');
    if (!bar) return;
    ensureStyle();
    if (bar.getAttribute('data-ds-b') === null) bar.setAttribute('data-ds-b', '1');

    var preisEl = document.getElementById('DsCartBarPrice');
    if (preisEl) {
      /* Reinen Preis im DOM merken statt in einer Closure-Variablen. Zustand in
         der Closure ueberlebt einen erneuten Skriptlauf nicht und haengte den
         Zusatz im Test ein zweites Mal an. Aus dem DOM gelesen ist sync()
         idempotent, egal wie oft es laeuft, und ein Preiswechsel durch das Theme
         setzt die Basis automatisch neu. */
      var roh = preisEl.textContent.trim();
      if (roh.indexOf(ZUSATZ) === -1) preisEl.setAttribute('data-ds-basis', roh);
      var basis = preisEl.getAttribute('data-ds-basis') || roh.split(ZUSATZ)[0];
      var g = groesse();
      setText(preisEl, g ? (basis + ZUSATZ + g) : basis);
    }

    var textEl = document.getElementById('DsCartBarText');
    var btn = document.getElementById('DsCartBarBtn');
    faerbeKnopf(btn);
    if (btn && btn.getAttribute('data-label-add') !== LABEL &&
        !btn.classList.contains('ds-cart-bar__btn--success')) {
      btn.setAttribute('data-label-add', LABEL);
    }
    if (textEl && !btn.disabled && !btn.classList.contains('ds-cart-bar__btn--success')) {
      setText(textEl, LABEL);
    }

    // Anzeige-Ereignis fuer Arm B, einmal je Seitenaufruf
    if (bar.getAttribute('data-state') === 'visible' && !bar.getAttribute('data-ds-b-shown')) {
      bar.setAttribute('data-ds-b-shown', '1');
      push('ds_sticky_atc_shown_v2', { variant_id: btn ? btn.getAttribute('data-variant-id') : null });
    }
  }

  function start() {
    var bar = document.getElementById('DsCartBar');
    if (!bar) return;
    var btn = document.getElementById('DsCartBarBtn');

    // Klick-Ereignis fuer Arm B. Capture, damit es auch feuert, wenn der
    // Bestandshandler die Weitergabe stoppt. Deckt Direktklick auf den Knopf
    // und den Weg ueber die Flaeche ab, weil dieser btn.click() ausloest.
    if (btn) {
      btn.addEventListener('click', function () {
        push('ds_sticky_atc_click_v2', { variant_id: btn.getAttribute('data-variant-id') });
      }, true);
    }

    // Ganze Leiste klickbar. Listener statt Overlay: ein Overlay wuerde das
    // Markieren von Text blockieren.
    bar.addEventListener('click', function (e) {
      if (e.target.closest('button, a')) return;
      if (String(window.getSelection())) return;
      if (btn && !btn.disabled) btn.click();
    });

    sync();
    setInterval(sync, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
